/* eslint-disable no-useless-escape */
import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/pages/ResourceSetting/Widgets/TextField';

const URLRegex = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/);

export default function HostingUrlField({
  value,
  onChange,
  disabled,
  required,
}) {
  return (
    <TextField
      singleLine
      title="廣告導入連結"
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      valid={!value || URLRegex.test(value)}
    />
  );
}

HostingUrlField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

HostingUrlField.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  required: false,
};
